import React from "react";
import {
  FormControl,
  FormLabel,
  Input,
  Stack,
  HStack,
  Button,
  Select,
  InputGroup,
  IconButton,
  InputRightAddon,
  FormErrorMessage,
} from "@chakra-ui/react";
import { FieldArray, Field } from "formik";
import { MdOutlineAdd, MdClose } from "react-icons/md";
import { validateField } from "../../../../../utils/Validaciones";

function MallaForm({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  expanded,
  setFieldValue,
  calcTons,
  calcTonsXdia,
  mostrarResultado,
  mallas,
}) {
  return (
    <HStack w="100%" justifyContent={!expanded ? "space-between" : "unset"}>
      <FieldArray name="mallas">
        {({ push, remove }) => (
          <Stack>
            <HStack
              w="100%"
              justifyContent={!expanded ? "space-between" : "unset"}
            >
              <FormControl w={"200px"} placeSelf={"start"}>
                <FormLabel fontWeight="semibold">Malla</FormLabel>
                <Stack>
                  {values.mallas.map((malla, index) => (
                    <Select
                      key={index}
                      placeholder="Tipo de malla"
                      name={`mallas[${index}].tipoMalla`}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.mallas[index].tipoMalla}
                      w={"200px"}
                      isDisabled={values.etapasDiaMalla === ""}
                    >
                      {mallas?.map((malla) => {
                        return (
                          <option key={malla.id} value={malla.descripcion}>
                            {malla.descripcion}
                          </option>
                        );
                      })}
                    </Select>
                  ))}
                </Stack>
              </FormControl>
              <Stack placeSelf={"start"}>
                <FormLabel fontWeight="semibold" m={"unset"}>
                  Tns Arena por Sandcube
                </FormLabel>
                {values.mallas.map((_, index) => (
                  <Field
                    key={index}
                    name={`mallas[${index}].tnsArenaSc`}
                    validate={(value) =>
                      validateField(
                        "decimal",
                        value?.toString(),
                        `Scs en malla ${index + 1}`,
                      )
                    }
                  >
                    {({ field }) => (
                      <FormControl
                        isInvalid={
                          errors.mallas && errors?.mallas[index]?.tnsArenaSc
                        }
                        w={"2xs"}
                        isRequired
                      >
                        <InputGroup>
                          <Input
                            {...field}
                            w={"100px"}
                            type="text"
                            maxLength={5} // 2 dígitos + punto + 2 decimales
                            placeholder="Número"
                            name={`mallas[${index}].tnsArenaSc`}
                            onChange={(e) => {
                              const { value } = e.target;
                              // Verifica si ya se han ingresado 2 dígitos y agrega una coma
                              if (
                                value.length === 2 &&
                                /^[0-9]{2}$/.test(value)
                              ) {
                                handleChange({
                                  target: {
                                    value: value + ".",
                                    name: e.target.name,
                                  },
                                });
                              } else {
                                handleChange(e);
                              }

                              calcTons(values, index, setFieldValue);
                              calcTonsXdia(values, index, setFieldValue);
                            }}
                            onBlur={(e) => {
                              // Asegura que el valor tenga formato decimal correcto al perder el foco
                              let { value } = e.target;
                              if (value) {
                                setFieldValue(
                                  `mallas[${index}].tnsArenaSc`,
                                  value,
                                );
                              }
                              handleBlur(e);
                              calcTons(values, index, setFieldValue);
                              calcTonsXdia(values, index, setFieldValue);
                            }}
                            borderTopRightRadius={0}
                            borderBottomRightRadius={0}
                            isDisabled={values.etapasDiaMalla === ""}
                            value={values.mallas[index]?.tnsArenaSc || ""}
                          />
                          <InputRightAddon
                            color="white"
                            bg="brand.gris_primario"
                            isDisabled={values.etapasDiaMalla === ""}
                          >
                            promedio
                          </InputRightAddon>
                        </InputGroup>

                        <FormErrorMessage>
                          {touched.mallas &&
                            touched.mallas[index]?.tnsArenaSc &&
                            errors.mallas &&
                            errors?.mallas[index]?.tnsArenaSc}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                ))}
              </Stack>
              <FormControl w={"200px"} placeSelf={"start"}>
                <FormLabel fontWeight="semibold">Tipo de Arena</FormLabel>
                <Stack>
                  {values.mallas.map((elemento, index) => (
                    <Select
                      key={elemento.index}
                      name={`mallas[${index}].tipoArenaMalla`}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.mallas[index].tipoArenaMalla || "seca"}
                      w={"200px"}
                      isDisabled={values.etapasDiaMalla === ""}
                    >
                      <option value="seca">Seca</option>
                      <option value="humeda">Humeda</option>
                    </Select>
                  ))}
                </Stack>
              </FormControl>
              <Stack placeSelf={"start"}>
                <FormLabel fontWeight="semibold" m={"unset"}>
                  Sandcubes por Etapas
                </FormLabel>
                {values.mallas.map((_, index) => (
                  <Field
                    key={index}
                    name={`mallas[${index}].scEtapas`}
                    validate={(value) =>
                      validateField(
                        "number",
                        value?.toString(),
                        `Scs por etapa ${index + 1}`,
                      )
                    }
                  >
                    {({ field }) => (
                      <FormControl
                        isInvalid={
                          errors.mallas && errors?.mallas[index]?.scEtapas
                        }
                        w={"2xs"}
                      >
                        <InputGroup key={index}>
                          <Input
                            {...field}
                            w={"100px"}
                            type="number"
                            placeholder="Número"
                            name={`mallas[${index}].scEtapas`}
                            onChange={(e) => {
                              handleChange(e);
                              calcTons(values, index, setFieldValue);
                              calcTonsXdia(values, index, setFieldValue);
                            }}
                            onBlur={(e) => {
                              handleBlur(e);
                              calcTons(values, index, setFieldValue);
                              calcTonsXdia(values, index, setFieldValue);
                            }}
                            isDisabled={values.etapasDiaMalla === ""}
                            value={values.mallas[index].scEtapas}
                          />
                          <InputRightAddon
                            color="white"
                            bg="brand.gris_primario"
                            isDisabled={values.etapasDiaMalla === ""}
                          >
                            promedio
                          </InputRightAddon>
                        </InputGroup>

                        <FormErrorMessage>
                          {touched.mallas &&
                            touched.mallas[index]?.scEtapas &&
                            errors.mallas &&
                            errors?.mallas[index]?.scEtapas}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                ))}
              </Stack>
              <FormControl w={"200px"} placeSelf={"start"}>
                <FormLabel fontWeight="semibold">
                  Target tons. por día
                </FormLabel>
                <Stack>
                  {values.mallas.map((elemento, index) => (
                    <HStack key={elemento.index}>
                      <Input
                        w={index !== 0 ? "200px" : "150px"}
                        type="text"
                        placeholder="Cantidad"
                        name={`mallas[${index}].targetTnsDiaM`}
                        onChange={(e) => {
                          handleChange(e);
                          calcTonsXdia(values, index, setFieldValue);
                        }}
                        onBlur={(e) => {
                          handleChange(e);
                          calcTonsXdia(values, index, setFieldValue);
                        }}
                        value={mostrarResultado(
                          values.mallas[index].targetTnsDiaM,
                        )}
                        readOnly
                        bg="brand.gris_medio"
                        _placeholder={{ color: "white" }}
                        isDisabled={values.etapasDiaMalla === ""}
                      />
                      {index !== 0 && (
                        <IconButton
                          key={elemento.index}
                          fontSize="12px"
                          variant="link"
                          onClick={() => remove(index)}
                          isDisabled={values.mallas.length <= 1}
                          icon={<MdClose />}
                        />
                      )}
                    </HStack>
                  ))}
                </Stack>
              </FormControl>
            </HStack>
            <Stack placeSelf="start">
              <Button
                color="brand.naranja"
                placeSelf="self-start"
                fontSize="12px"
                variant="link"
                size="lg"
                leftIcon={<MdOutlineAdd size={18} color="#FF8200" />}
                onClick={() => {
                  push({
                    malla: "",
                    sandcubesEtapas: "",
                    tnsArenaSandcube: "",
                    tipoArena: "",
                    targetTnsDiaM: "",
                  });
                }}
                isDisabled={values.etapasDiaMalla === ""}
                textColor="black"
              >
                Agregar
              </Button>
            </Stack>
          </Stack>
        )}
      </FieldArray>
    </HStack>
  );
}

export default MallaForm;
